import { Component, Input } from '@angular/core';
import { FilterDataService } from '../filter-data.service';

@Component({
  standalone: false,
  selector: 'app-filter-boolean',
  templateUrl: './filter-boolean.component.html',
  styleUrls: ['./filter-boolean.component.scss']
})
export class FilterItemBooleanComponent {
  @Input() filterName: string;

  constructor(public dataService: FilterDataService) { }

  get value(): string {
    return this.dataService.curFilter()[0] ?? '';
  }

  onChange(value: string) {
    this.dataService.curFilter()[0] = value;
  }
}
